import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "reviews-section" }
const _hoisted_2 = { class: "top-chip" }
const _hoisted_3 = { class: "avg-number" }
const _hoisted_4 = { class: "count" }
const _hoisted_5 = {
  key: 0,
  class: "carousel-container"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "card-header" }
const _hoisted_8 = { class: "author" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "meta" }
const _hoisted_11 = ["href"]
const _hoisted_12 = {
  key: 1,
  class: "username"
}
const _hoisted_13 = { class: "card-body" }
const _hoisted_14 = { class: "text" }
const _hoisted_15 = { class: "card-footer" }
const _hoisted_16 = { class: "rating" }
const _hoisted_17 = { class: "date" }
const _hoisted_18 = {
  key: 1,
  class: "empty"
}
const _hoisted_19 = {
  key: 2,
  class: "loading"
}
const _hoisted_20 = {
  key: 3,
  class: "error"
}
const _hoisted_21 = { class: "modal" }
const _hoisted_22 = { class: "modal-header" }
const _hoisted_23 = { class: "author" }
const _hoisted_24 = ["src"]
const _hoisted_25 = { class: "meta" }
const _hoisted_26 = ["href"]
const _hoisted_27 = { key: 1 }
const _hoisted_28 = { class: "modal-body" }
const _hoisted_29 = { class: "modal-review-header" }
const _hoisted_30 = { class: "date" }
const _hoisted_31 = { class: "text" }

import { onMounted, ref, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { getReviews, calculateAverageRating } from '@/services/reviewsService.js'
import 'vue3-carousel/dist/carousel.css'
import { Carousel, Slide, Navigation } from 'vue3-carousel'
import Stars from '@/components/StarRating.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'ReviewsSection',
  props: {
    owner: { default: 'DIMFLIX' },
    repo: { default: 'dimflix.github.io' },
    category: { default: 'Reviews' }
  },
  setup(__props: any) {

const props = __props

const { t, locale } = useI18n()

const loading = ref(true)
const error = ref('')
const reviews = ref<Array<any>>([])

const averageRating = computed(() => calculateAverageRating(reviews.value))

function formatDate(d: string) {
  try {
    return new Date(d).toLocaleDateString(locale.value, { year: 'numeric', month: 'short', day: 'numeric' })
  } catch {
    return d
  }
}

async function load() {
  loading.value = true
  error.value = ''
  try {
    const data = await getReviews(props.owner, props.repo, props.category)
    reviews.value = data
  } catch (e: any) {
    error.value = t('reviews.loadError')
  } finally {
    loading.value = false
  }
}

onMounted(load)




// --- Full Review Modal ---
const showReviewModal = ref(false)
const selectedReview = ref<any>(null)

function openReviewModal(review: any) {
  selectedReview.value = review
  showReviewModal.value = true
}
function closeReviewModal() {
  showReviewModal.value = false
  selectedReview.value = null
}

// --- Carousel Config ---
const carouselConfig = ref({
  itemsToShow: 1.15,
  wrapAround: true,
  transition: 500,
  snapAlign: 'center',
  breakpoints: {
    700: {
      itemsToShow: 1.3,
      snapAlign: 'center',
    },
    1100: {
      itemsToShow: 1.6,
      snapAlign: 'center',
    },
  }
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("svg", {
        class: "stat-star",
        viewBox: "0 0 24 24",
        "aria-hidden": "true"
      }, [
        _createElementVNode("path", {
          d: "M12 2.5l2.9 5.88 6.5.95-4.7 4.58 1.1 6.46L12 17.9 6.2 20.4l1.1-6.46-4.7-4.58 6.5-.95L12 2.5z",
          fill: "#f5b301",
          stroke: "#f2c94c",
          "stroke-width": "1.5",
          "stroke-linejoin": "round",
          "stroke-linecap": "round"
        })
      ], -1)),
      _createElementVNode("span", _hoisted_3, _toDisplayString(averageRating.value.toFixed(1)), 1),
      _createElementVNode("span", _hoisted_4, "· " + _toDisplayString(reviews.value.length), 1)
    ]),
    (!loading.value && reviews.value.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(_unref(Carousel), _normalizeProps(_guardReactiveProps(carouselConfig.value)), {
            addons: _withCtx(() => [
              _createVNode(_unref(Navigation))
            ]),
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(reviews.value, (r) => {
                return (_openBlock(), _createBlock(_unref(Slide), {
                  key: r.id
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      class: "review-card",
                      onClick: ($event: any) => (openReviewModal(r))
                    }, [
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                          (r.author?.avatar)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                class: "avatar",
                                src: r.author.avatar,
                                alt: "avatar"
                              }, null, 8, _hoisted_9))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_10, [
                            (r.author?.url)
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 0,
                                  href: r.author.url,
                                  target: "_blank",
                                  rel: "noopener noreferrer",
                                  class: "username"
                                }, _toDisplayString(r.author?.username || r.author?.name || 'User'), 9, _hoisted_11))
                              : (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(r.author?.username || r.author?.name || 'User'), 1))
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("blockquote", _hoisted_14, _toDisplayString(r.text), 1)
                      ]),
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, [
                          _createVNode(Stars, {
                            value: r.rating,
                            size: 24
                          }, null, 8, ["value"])
                        ]),
                        _createElementVNode("span", _hoisted_17, _toDisplayString(formatDate(r.createdAt)), 1)
                      ])
                    ], 8, _hoisted_6)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }, 16)
        ]))
      : _createCommentVNode("", true),
    (!loading.value && !reviews.value.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(_unref(t)('reviews.noReviews')), 1))
      : _createCommentVNode("", true),
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(_unref(t)('reviews.loading')), 1))
      : _createCommentVNode("", true),
    (error.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(error.value), 1))
      : _createCommentVNode("", true),
    (showReviewModal.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 4,
          class: "modal-mask",
          onClick: _withModifiers(closeReviewModal, ["self"])
        }, [
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                (selectedReview.value.author?.avatar)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      class: "avatar",
                      src: selectedReview.value.author.avatar,
                      alt: "avatar"
                    }, null, 8, _hoisted_24))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_25, [
                  (selectedReview.value.author?.url)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: selectedReview.value.author.url,
                        target: "_blank",
                        rel: "noopener noreferrer"
                      }, _toDisplayString(selectedReview.value.author?.name || selectedReview.value.author?.username || 'User'), 9, _hoisted_26))
                    : (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(selectedReview.value.author?.name || selectedReview.value.author?.username || 'User'), 1))
                ])
              ]),
              _createElementVNode("button", {
                type: "button",
                class: "modal-close",
                onClick: closeReviewModal
              }, "✕")
            ]),
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("div", _hoisted_29, [
                _createVNode(Stars, {
                  value: selectedReview.value.rating
                }, null, 8, ["value"]),
                _createElementVNode("span", _hoisted_30, _toDisplayString(formatDate(selectedReview.value.createdAt)), 1)
              ]),
              _createElementVNode("blockquote", _hoisted_31, _toDisplayString(selectedReview.value.text), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})